<template>
  <button id="button" :class="action" :style="color" @click="update">
      {{ this.text }}
  </button>
</template>

<script>

export default {
  name: 'Button',
  props: ['action','text','colors','href','type'],
  mounted:function(){
    this.getColor();
  },
  data: function(){
    return{
      color: 'background-color: #ffffff'
    }
  },
  methods: {
    update(){
        this.$emit(this.action)
    },
    getColor(){
      for (var prop in this.colors) {
        if ( Object.prototype.hasOwnProperty.call(this.colors, prop) && prop == this.action ) {
          this.color = "background-color: "+this.colors[prop];
        }
      }
    }
  }
}
</script>
